<template>
  <div>
    <div class="material-table1-widget dashboard_top_bar">
      <button class="btn btn-default btn-new" @click="temp_money.money_type = 'receivable';money_type = 'income';newMoneyModal=true"><i class="fa fa-plus"></i>&nbsp;建立收入</button>
      <button class="btn btn-default btn-new" @click="temp_money.money_type = 'payable';money_type = 'expend';newMoneyModal=true"><i class="fa fa-minus"></i>&nbsp;建立支出</button>
      <!-- <button class="btn btn-default pull-right"><i class="far fa-file-excel"></i>&nbsp;Excel匯出</button> -->
    </div> 
    <div class="widget-wrap">
      <div class="block-header  clearfix">
        <button @click="now_at='index'" v-bind:class="{'active': now_at=='index' }" class="btn btn-default pull-left relative" style="margin-right:10px;"><i class="far fa-chart-bar"></i> 概覽</button>
        <div role="group" aria-label="..." class="btn-group pull-left" style="margin-right:10px;">
          <button @click="now_at='receivable';getModalTitle()" class="btn btn-default relative" v-bind:class="{'active': now_at=='receivable' }">應收({{filteMoneyByType('receivable').length}}) <span v-if="warningMoneyByType('receivable').length != 0" class="btn btn-danger btn-circle btn-circle-xs notice_circle">{{warningMoneyByType('receivable').length}}</span></button>
          <button @click="now_at='received';getModalTitle()" class="btn btn-default" v-bind:class="{'active': now_at=='received' }">實收({{filteMoneyByType('received').length}})</button>
        </div>
        <div role="group" aria-label="..." class="btn-group pull-left" style="margin-right:10px;">
          <button @click="now_at='payable';getModalTitle()" class="btn btn-default relative" v-bind:class="{'active': now_at=='payable' }">應付({{filteMoneyByType('payable').length}}) <span v-if="warningMoneyByType('payable').length != 0" class="btn btn-danger btn-circle btn-circle-xs notice_circle">{{warningMoneyByType('payable').length}}</span></button>
          <button @click="now_at='paid';getModalTitle()" class="btn btn-default" v-bind:class="{'active': now_at=='paid' }">實付({{filteMoneyByType('paid').length}})</button>
        </div>
        <dateFilter v-if="use_filter" :show_month="use_filter" :now_year="now_year" :now_month="now_month" :years="years" @changeYear="changeYear" @changeMonth="changeMonth"></dateFilter>
      </div>
      <div>
        <div class="widget-container">
          <div class="widget-content text-left" v-if="now_at=='index'">
            <div class="row">
              
              <div class="col-sm-6">
                <h4 class="pointer" @click="now_at='receivable'">總應收：<span>$ {{sumOfMoney('receivable').toLocaleString()}}</span></h4>
                <h4 class="pointer" @click="now_at='receive'">總實收：<span>$ {{sumOfMoney('received').toLocaleString()}}</span></h4>
                <h4>總應付：<span>$ {{sumOfMoney('payable').toLocaleString()}}</span></h4>
                <h4>總實付：<span>$ {{sumOfMoney('paid').toLocaleString()}}</span></h4>
                
              </div>
              <div class="col-sm-6">
                <h4>預計損益<small class="text-gray">(總收入-總支出)</small>：$ {{(sumOfMoney('receivable') + sumOfMoney('received') - sumOfMoney('payable') - sumOfMoney('paid')).toLocaleString()}}</h4>
                <h4>實際損益<small class="text-gray">(實收-實付)</small>：$ {{(sumOfMoney('received') - sumOfMoney('paid')).toLocaleString()}}</h4>
                <h4>預計毛利率：{{ estimateGrossMargin() }} %</h4>
                <h4>實際毛利率：{{ realGrossMargin() }} %</h4>
              </div>
            </div>
          </div>
          <div class="widget-content text-left" v-else>
            <h4>{{title}} (共{{filteMoneyByType(now_at).length}}筆，NT$ {{sumOfMoney(now_at).toLocaleString()}})</h4>
            <table class="table table-bordered">
              <tr>
  							<th v-bind:class="header_color" class="col-xs-1" v-if="now_at=='paid' || now_at=='received'">{{th2}}</th>
  							<th v-bind:class="header_color" class="col-xs-1" v-if="now_at=='paid' || now_at=='received'">{{th1}}</th>
                <th v-bind:class="header_color" class="col-xs-2" v-if="now_at=='payable' || now_at=='receivable'">{{th1}}</th>
                <th v-bind:class="header_color" class="col-xs-4" v-if="deal_token!=''">項目</th>
                <th v-bind:class="header_color" class="col-xs-2" v-if="deal_token==''">項目</th>
                <th v-bind:class="header_color" class="col-xs-2" v-if="deal_token==''">專案</th>
                <th v-bind:class="header_color" class="col-xs-1">分類</th>
                <th v-bind:class="header_color" class="col-xs-2">金額</th>
                <th v-bind:class="header_color" class="col-xs-1">發票資訊</th>
                <th v-bind:class="header_color" class="col-xs-1"></th>
              </tr>
              <tr v-if="filteMoneyByType(now_at).length == 0">
              	<td colspan="9" class="text-center">沒有款項資料</td>
              </tr>
              <tr v-for="m in filteMoneyByType(now_at)">
              	<td v-if="now_at=='paid' || now_at=='received'" v-html='m.finish_at'></td>
                <td v-html='calculateDateLate(m)'></td>
                <td><b>{{m.title}}</b></td>
                <td class="pointer" @click="goToDeal(m)" v-if="deal_token==''">{{m.deal_title}}</td>
                <td>{{m.money_category_name}}</td>
                <td><b>NT$ {{m.amount.toLocaleString()}}</b></td>
                <td v-if="now_at=='pay' || now_at=='receive'">{{getPaymentWay(m.payment_way)}}</td>
                <td><span v-html="invoiceImformation(m)"></span></td>
                <td>
                	<button @click="showNote(m)" class="btn btn-success btn-xs" v-if="m.note && m.note != ''"><i class="fa fa-comment"></i></button>
                  <button @click="editMoney(m)" class="btn btn-xs btn-default"><i class="fas fa-pencil-alt"></i></button>
                  <button @click="showDeleteAlarm(m)" class="btn btn-xs btn-danger"><i class="far fa-trash-alt"></i></button>
                  
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template start-->
    <div v-if="newMoneyModal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="newMoneyModal=false;resetTempMoney()">
          <div class="modal-container modal-center col-md-6" @click.stop>
            <div class="modal-header" style="display:block">
              <a href="#" class="btn-close" @click="newMoneyModal=false;resetTempMoney()">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms" style="overflow:scroll">
              <div>
                <div class="form">
                  <h4><span v-if="temp_money.deal_token == ''">建立</span>
                  	<span v-else>編輯</span>
                  	<span v-html="getTempMoneyName()"></span>
                  </h4>
                  <div class="row">
                  	<div class="col-md-6">
                  		<div class="form-group">
		                    <label>項目名稱*：</label>
		                    <input class="form-control" type="text" placeholder="項目名稱" name="title" v-model="temp_money.title" v-validate="'required'">
                      	<span v-show="errors.has('title')" class="help is-danger">請輸入名稱</span>
		                  </div>
                  	</div>
                  	<div class="col-md-6">
                  		<div class="form-group">
		                    <label>項目分類*：</label>
		                    <select style="padding-left:13px !important;" name="money_category_id" v-model="temp_money.money_category_id" class="form-control" v-validate="'required'">
		                    	<option value="">請選擇</option>
		                      <option v-for="category in categories" v-if="checkCategoryMoneyType(category)" :selected="temp_money.money_category_id==category.id" :value='category.id'>{{category.name}}</option>
		                    </select>
                      	<span v-show="errors.has('money_category_id')" class="help is-danger">請選擇</span>
		                  </div>
                  	</div>
                  	
                  	<div class="col-md-6">
                  		<div class="form-group">
			                  <label v-if="temp_money.money_type=='receivable' || temp_money.money_type=='received'">應收日期*</label>
			                  <label v-if="temp_money.money_type=='payable' || temp_money.money_type=='paid'">應付日期*</label>
			                  <datepicker input-class="form-control" v-model="temp_money.date" :format="customFormatter" language="zh" v-validate="'required'"></datepicker>
			                </div>
                  	</div>
                  	<div class="col-md-6">
                  		<div class="form-group">
		                    <label v-if="temp_money.money_type=='receivable' || temp_money.money_type=='received'">實收日期</label>
			                  <label v-if="temp_money.money_type=='payable' || temp_money.money_type=='paid'">實付日期</label>
		                    <datepicker :clear-button="true" clear-button-icon="fa fa-times" input-class="form-control" v-model="temp_money.finish_at" :format="customFormatter" language="zh"></datepicker>
		                  </div>
                  	</div>
                  	<div class="col-md-6">
                  		<div class="form-group">
		                    <label>金額*：</label>
		                    <input class="form-control" type="number" placeholder="金額" name="amount" v-model="temp_money.amount" v-validate="'required|numeric'">
                      <span v-show="errors.has('amount')" class="help is-danger">請輸入金額</span>
		                  </div>
                  	</div>
                  	<div class="col-md-6">
                  		<div class="form-group">
		                    <label>是否開發票：</label>
		                    <select style="padding-left:13px !important;" v-model="temp_money.invoice_status" class="form-control" v-validate="'required'">
		                      <option :selected="temp_money.invoice_status== 'no_invoice'" value="no_invoice">無發票</option>
		                      <option :selected="temp_money.invoice_status== 'not_create'" value="not_create">未開發票</option>
		                      <option :selected="temp_money.invoice_status== 'created'" value="created">已開發票</option>
		                    </select>
                      	<span v-show="errors.has('invoice_at')" class="help is-danger">請選擇</span>
		                  </div>
                  	</div>
                  	<div class="col-md-6" v-if="temp_money.invoice_status == 'created'">
                  		<div class="form-group">
		                    <label>發票日期*：</label>
		                    <datepicker input-class="form-control" v-model="temp_money.invoice_at" name="invoice_at" :format="customFormatter" language="zh" :required="true"></datepicker>
		                  </div>
                  	</div>
                  	<div class="col-md-6">
                  		<div class="form-group">
		                    <label v-if="temp_money.money_type == 'receivable' || temp_money.money_type == 'received'">收款方式：</label>
		                    <label v-if="temp_money.money_type=='payable' || temp_money.money_type=='paid'">付款方式：</label>
		                    <select style="padding-left:13px !important;" v-model="temp_money.payment_way" class="form-control">
		                      <option value="no_payment">無</option>
		                      <option value="transfer">銀行轉帳</option>
		                      <option value="cash">現金</option>
		                      <option value="ticket">支票</option>
		                    </select>
		                  </div>
                  	</div>
                  	<div class="col-md-12">
                  		<div class="form-group">
		                    <label>備註：</label>
		                    <textarea class="form-control" placeholder="備註內容" name="note" v-model="temp_money.note"></textarea>
		                  </div>
                  	</div>
                  </div>
                 
                </div>
                <div class="text-center">
                  <button class="btn btn-success" @click="submitTempMoney()" v-if="temp_money.loading==false">送出</button>
                  <button type="button" class="btn btn-success disabled" disabled="disabled" v-else>
                    <i class="fa fa-spinner fa-spin "></i> 送出中
                  </button>
                  <button class="btn btn-default" @click="newMoneyModal = false;resetTempMoney()">取消</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template start-->
    <div v-if="showNoteModal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="showNoteModal=false;resetTempMoney()">
          <div class="modal-container modal-center col-md-6" @click.stop>
            <div class="modal-header" style="display:block">
              <a href="#" class="btn-close" @click="showNoteModal=false;resetTempMoney()">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms" style="overflow:scroll">
              <div>
                <pre class="text-left" style="background: #fff; margin-bottom: 30px;">{{temp_money.note}}</pre>
                <div class="text-center">	
                  <button class="btn btn-default" @click="showNoteModal = false;resetTempMoney()">關閉</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template start-->
    <div v-if="showDeleteModal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="showDeleteModal=false;resetTempMoney()">
          <div class="modal-container modal-center col-md-6" @click.stop>
            <div class="modal-header" style="display:block">
              <a href="#" class="btn-close" @click="showDeleteModal=false;resetTempMoney()">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms" style="overflow:scroll">
              <div>
                <p>你確定刪除此筆款項嗎？</p>
                <p>{{temp_money.title}} , 金額：NT$ {{temp_money.amount.toLocaleString()}}</p>
                <div class="text-center">	
                	<button class="btn btn-danger" @click="deleteMoney(temp_money)">確定刪除</button>
                  <button class="btn btn-default" @click="showDeleteModal = false;resetTempMoney()">取消</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCookie } from '../../assets/js/elffy_js/cookie.js'
import moment from 'moment';
import dateFilter from './DateFilter.vue';
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'finance_box',
  data() {
    return {
      deal_token: this.$route.params.deal_token || '',
      now_at: "index",
      years: [new Date().getFullYear()],
      newMoneyModal: false,
      showNoteModal: false,
      showDeleteModal: false,
      select_type: '',
      title: "",
      th1: "",
      th2: "",
      money_type: 'income',
      header_color: 'table-active',
      temp_money: {loading:false},
      money:[],
      categories:[],
      now_year: new Date().getFullYear(),
      now_month: new Date().getMonth()+1,
    }
  },
  created() {
    this.getMoneys()
    this.resetTempMoney()
  },
  components: {
    Datepicker,dateFilter
  },
  props: ['toggle_aside','use_filter'],
  computed: {

  },
  methods: {
  	filteMoneyByType(type){
  		let vm = this

      if(this.use_filter){
      	switch(type){
      		case 'index':
	      	case 'all':
	      		if(vm.now_month == 'all'){
	      			return vm.money.filter(m => new Date(m.date).getFullYear() == vm.now_year)
	      		}else{
	      			return vm.money.filter(m => new Date(m.date).getFullYear() == vm.now_year && new Date(m.date).getMonth()+1 == vm.now_month)
	      		}
	    		case 'receivable':
	  			case 'payable':
	  				if(vm.now_month == 'all'){
	      			return _.orderBy(vm.money.filter(m => m.money_type == type && new Date(m.date).getFullYear() == vm.now_year),'date')
	      		}else{
	      			return _.orderBy(vm.money.filter(m => m.money_type == type && new Date(m.date).getFullYear() == vm.now_year && new Date(m.date).getMonth()+1 == vm.now_month),'date')
	      		}
	  			case 'received':
					case 'paid':
						if(vm.now_month == 'all'){
	      			return _.orderBy(vm.money.filter(m => m.money_type == type && new Date(m.finish_at).getFullYear() == vm.now_year),'finish_at')
	      		}else{
	      			return _.orderBy(vm.money.filter(m => m.money_type == type && new Date(m.finish_at).getFullYear() == vm.now_year && new Date(m.finish_at).getMonth()+1 == vm.now_month),'finish_at')
	      		}
						
	      }
      	
      }else{
      	switch(type){
      		case 'index':
	      	case 'all':
	      	  return vm.money
	    		case 'receivable':
	  			case 'payable':
	    			return _.orderBy(vm.money.filter(m => m.money_type == type),'date')
	    		case 'received':
					case 'paid':
						return _.orderBy(vm.money.filter(m => m.money_type == type),'finish_at')
	      }
      }
    },
  	
  	getModalTitle(){
  		let vm = this
      switch(vm.now_at){
        case "receivable":
          vm.title = '應收款項'
          vm.th1 = "應收日期"
          vm.th2 = "實收日期"
          vm.header_color = 'table-info'
          break;
        case "received":
          vm.title = '實收款項'
          vm.th1 = "應收日期"
          vm.th2 = "實收日期"
          vm.header_color = 'table-success'
          break;
        case "payable":
          vm.title = '應付款項'
          vm.th1 = "應付日期"
          vm.th2 = "實付日期"
          vm.header_color = 'table-warning'
          break;
        case "paid":
          vm.title = '實付款項'
          vm.th1 = "應付日期"
          vm.th2 = "實付日期"
          vm.header_color = 'table-danger'
          break;
      }
  	},
    goToDeal(m){
      this.$router.push({ name: 'deal_finance', params: { deal_token: m.deal_token } })
    },
    getMoneys(){
      let vm = this
      this.axios.get('finance_moneys?deal_token='+vm.deal_token)
      .then(function(response) {
        if (response.status == 200) {
          vm.money = response['data']['data']['finance_moneys']
          vm.years = response['data']['data']['years']
          vm.categories = response['data']['data']['money_categories']
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    totalUnReceive(){
      return (this.sumOfMoney('receivable') - this.sumOfMoney('receive'))
    },
    totalUnPay(){
      return (this.sumOfMoney('payable') - this.sumOfMoney('pay'))
    },
    sumOfMoney(type) {
      let amount = 0
      this.filteMoneyByType(type).forEach(function(m) {
        amount += m.amount
      })
      return amount
    },
    estimateGrossMargin(){
      let vm = this
      let result = 0
      if(vm.sumOfMoney('receivable')!=0){
        result = ((vm.sumOfMoney('receivable') + vm.sumOfMoney('received') - vm.sumOfMoney('payable') - vm.sumOfMoney('paid'))*100/(vm.sumOfMoney('receivable') + vm.sumOfMoney('received'))).toFixed(1)
      }
      return result
    },
    customFormatter(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    realGrossMargin(){
      let vm = this
      let result = 0
      if(vm.sumOfMoney('receivable')!=0){
        result = ((vm.sumOfMoney('received') - vm.sumOfMoney('paid'))*100/vm.sumOfMoney('received') ).toFixed(1)
      }
      return result
    },
    calculateDateLate(m){
      let vm = this
      let result = '<span style=margin-right:5px;>'+moment(m.date).format('YYYY-MM-DD')+'</span>'
      if( moment(new Date()) > moment(m.date) && m.money_type == 'receivable'){
        result += '<span class="btn btn-danger btn-circle  btn-circle-xs"><i class="fas fa-exclamation"></i></span>'
      }
      if( moment(new Date()) > moment(m.date) && m.money_type == 'payable'){
        result += '<span class="btn btn-danger btn-circle  btn-circle-xs"><i class="fas fa-exclamation"></i></span>'
      }
      return result
    },
    findMoneyByToken(token){
      let vm=this
      var result={}
      $.each(vm.money,function(key,value){
        if(value.token==token){
          result = value
        }
      })
      return result
    },
    warningMoneyByType(type){
      let vm = this
      if(this.use_filter){
      	if (vm.now_month == "all") {
      		return vm.money.filter(m => m.money_type == type && moment(new Date()) > moment(m.date) && new Date(m.date).getFullYear() == vm.now_year)
      	}else{
      		return vm.money.filter(m => m.money_type == type && moment(new Date()) > moment(m.date) && new Date(m.date).getFullYear() == vm.now_year && new Date(m.date).getMonth()+1 == vm.now_month)
      	}
      	
      }else{
      	return vm.money.filter(m => m.money_type == type && moment(new Date()) > moment(m.date))
      }
    },
    editMoney(m){
      let vm = this
      vm.temp_money = m
      vm.newMoneyModal=true
    },
    submitTempMoney(){
      let vm = this
      vm.temp_money.loading = true
      vm.temp_money.amount = parseInt(vm.temp_money.amount)

      this.$validator.validateAll().then((result) => {
        if (result) {

        	if(vm.temp_money.invoice_status == 'created' && vm.temp_money.invoice_at == ''){
        		vm.$toastr.w("如果已開發票，發票時間為必填欄位唷")
        		vm.temp_money.loading = false
        		return false
        	}

          if(vm.temp_money.token == ''){
		        //建立新的money
		        const vm = this;
		        this.axios.post('finance_moneys', {
		          money: vm.temp_money,
		        })
		        .then(function(response) {
		          if (response.status == 200) {
		            vm.money.push(response['data']['data']['finance_money'])
		            vm.now_at = vm.temp_money.money_type
		            vm.resetTempMoney()
		            vm.newMoneyModal = false

		          } else {
		          	vm.temp_money.loading = false
		          	vm.$toastr.w('無法建立，請稍後再試，已通知工程師進行問題排除')
		            console.log(response)
		          }
		        })
		        .catch(function(error) {
		        	vm.temp_money.loading = false
	          	vm.$toastr.w('無法建立，請稍後再試，已通知工程師進行問題排除')
		          console.log('error:', error)
		        });

		      }else{
		        //編輯 money
		        const vm = this;
		        this.axios.put('finance_moneys/id', {
		          money: vm.temp_money,
		        })
		        .then(function(response) {
		          if (response.status == 200) {
		            var old_money = vm.findMoneyByToken(vm.temp_money.token)
		            var index = vm.money.indexOf(old_money)
		            vm.money.splice(parseInt(index), 1)
		            vm.money.push(response['data']['data']['finance_money'])
		            vm.resetTempMoney()
		            vm.newMoneyModal = false

		          } else {
		          	vm.temp_money.loading = false
		          	vm.$toastr.w('無法建立，請稍後再試，已通知工程師進行問題排除')
		            console.log(response)
		          }
		        })
		        .catch(function(error) {
		        	vm.temp_money.loading = false
	          	vm.$toastr.w('無法建立，請稍後再試，已通知工程師進行問題排除')
		          console.log('error:', error)
		        })
		      }
        }else{
        	vm.temp_money.loading = false
        }
      });
    },
    deleteMoney(delete_money) {
      // delete in html
      var index = this.money.indexOf(delete_money)
      this.money.splice(parseInt(index), 1)
      let vm = this;
      // move products to other category
      vm.showDeleteModal = false;
      vm.resetTempMoney();

      this.axios.delete('finance_moneys/id', {
        params: {
          deal_token: delete_money.deal_token,
          token: delete_money.token,
        }
      })
      .then(function(response) {
        if (response.status == 200) {} else {
          console.log(response);
        }
      })
      .catch(function(error) {
        console.log('error:', error)

      });
    },
    resetTempMoney(){
      let vm = this
      vm.temp_money = {
        title: null ,
        money_type:'',
        date: new Date(),
        status:'',
        amount: null,
        invoice_status: 'no_invoice',
        invoice_at: null,
        payment_way:'no_payment',
        note:'',
        token:'',
        deal_token: vm.deal_token, 
        token: "",
        money_category_id: '',
        loading: false,
      }
    },
    getTempMoneyName(){
      let vm = this
      let result = ''
      switch(vm.temp_money.money_type){
        case "receivable":
          result = '收入款項'
          break;
        case "received":
          result = '收入款項'
          break;
        case "payable":
          result = '支出款項'
          break;
        case "paid":
          result = '支出款項'
          break;
        case "":
          result = ''
          break;
      }
      return result
    },
    getPaymentWay(w){
      let result = ''
      switch(w){
        case "no_payment":
          result = '無'
          break;
        case "cash":
          result = '現金'
          break;
        case "transfer":
          result = '轉帳'
          break;
        case "ticket":
          result = '支票'
          break;
      }
      return result
    },
    invoiceImformation(m){
    	var result = ''
    	switch(m.invoice_status){
    		case 'no_invoice':
    			result = "無發票"
    			break;
    		case 'not_create':
    			result = "<span class='label label-warning'>尚未開立</span>"
    			break;
    		case 'created':
    			if(m.invoice_at == ''){
    				result = "<span class='label label-success'>已開立</span><br>"
    			}else{
    				result = "<span class='label label-success'>已開立</span><br>" + moment(m.invoice_at).format('YYYY-MM-DD')
    			}
    			break;
    	}
    	return result
    },
    checkCategoryMoneyType(category){
    	var result = false
    	if(category.money_type == 'income' && (this.temp_money.money_type == 'received' || this.temp_money.money_type == 'receivable')){
    		result = true
    	}

    	if(category.money_type == 'expend' && (this.temp_money.money_type == 'paid' || this.temp_money.money_type == 'payable')){
    		result = true
    	}

    	return result
    },
    showNote(money){    	
    	this.temp_money = money
    	this.showNoteModal = true
    },
    showDeleteAlarm(money){    	
    	this.temp_money = money
    	this.showDeleteModal = true
    },
    changeYear(year){
    	this.now_year = year
    },
    changeMonth(month){
    	this.now_month = month
    }
  }
}
</script>


// WEBPACK FOOTER //
// FinanceBox.vue?29ed6a4c